












import PartnerDetail from '@/components/partner/PartnerDetail.vue';
import {Vue, Component} from 'vue-property-decorator';
@Component({
  components: {PartnerDetail}
})
export default class PartnerNew extends Vue {}
